module.exports = __webpack_public_path__ + "static/media/Feliz Navidad- Jose Feliciano lyrics [HQ].3227d8f0.mp3";